import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import Moment from 'moment';

export const baseURI = 'empresas/obligaciones-fiscales-de-contribuyentes/';

/**
 * GET Obligaciones Fiscales
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getObligacionesFiscalesContribuyente = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Obligacion Fiscal
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getObligacionFiscalContribuyente = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Obligacion Fiscal
  * @param {object} values
  * @returns {Promise<object|boolean>}
 */
export const postObligacionFiscalContribuyente = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values, {}, true));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Obligacion Fiscal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchObligacionFiscalContribuyente = async (id, values) => {
  try {
    // eslint-disable-next-line no-param-reassign
    values.fecha_ultimo_estado = new Moment();
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values, {}, true));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Obligacion Fiscal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteObligacionFiscalContribuyente = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
